/** Route-aware heading for the dashboard top bar (mirrors section context). */
export function getAdminTopBarHeading(pathname) {
  const p = (pathname || "").replace(/\/$/, "") || "/";

  if (p === "/admin/dashboard") {
    return { kicker: "Admin", title: "Overview" };
  }
  if (p === "/admin/dashboard/requests") {
    return { kicker: "Inbox", title: "Service requests" };
  }
  if (p.startsWith("/admin/dashboard/requests/")) {
    return { kicker: "Service requests", title: "Request detail" };
  }
  if (p === "/admin/dashboard/contact") {
    return { kicker: "Inbox", title: "Contact messages" };
  }
  if (p === "/admin/dashboard/email-analysis") {
    return { kicker: "Email analyser", title: "Analysis history" };
  }
  if (p.startsWith("/admin/dashboard/email-analysis/")) {
    return { kicker: "Email analyser", title: "Analysis details" };
  }
  if (p.startsWith("/admin/dashboard/contact/")) {
    return { kicker: "Contact", title: "Message detail" };
  }
  return { kicker: "Admin", title: "Dashboard" };
}
